import { Modal } from "react-bootstrap";
import "./UpgradeCardPopUp.scss";
import exportimages from "../../../../assets/images/exportImages";
import { formatCategoryName } from "../../../Bank/widget/widgetsCommonFunction";
import { ContactSalesTeamModal } from "./ContactSalesTeam";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toastResponse } from "../../../Common/Toast/Toast";
import { toast } from "react-toastify";
import { _get } from "../../../../api/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { setUserContactedSales } from "../../../../Redux/authSlice";
import PropTypes from "prop-types";

export const UpgradeCardSpecificModal = (props) => {
  const [contactSalesModal, setContactSalesModal] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [currentToast, setCurrentToast] = useState("");
  const params = useParams();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  const userRole = authReducer.userData.role?.toLowerCase();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSuccessFlag(false);
  }, []);

  const navigate = useNavigate();

  const showToast = (message, status) => {
    if (message !== currentToast) {
      if (status === "error") {
        toast.error(toastResponse("error", message));
      } else {
        toast.success(toastResponse("success", message));
      }
      setCurrentToast(message);
      setTimeout(() => setCurrentToast(""), 5500);
    }
  };

  const getTitleText = () => {
    if (successFlag) {
      return "Sales Contacted Successfully";
    }
    if (props?.cardData?.title) {
      return formatCategoryName(props?.cardData?.title);
    }
    return "NA";
  };

  const getDescriptionHtml = () => {
    if (successFlag) {
      return "<p>Your message has been successfully sent to our Sales team. They will be in touch with you shortly.</p><p className='mt-4'>Thank you for reaching out!</p>";
    }
    if (props?.cardData?.description) {
      return props?.cardData?.description;
    }
    return "NA";
  };

  const handleClick = async () => {
    if (successFlag) {
      props.onHide();
      let currentUrl = globalThis.location.href;
      if (
        currentUrl.includes("/financial-health-score") ||
        currentUrl.includes("/drilldown/graph")
      ) {
        navigate(`/bank/health-analysis/report/${params?.hid}`);
      }
    } else {
      const getExistingTier = () => {
        if (props?.cardData?.name === "upgrade_email_campaign") {
          return "Pro";
        }
        return "Freemium";
      };

      const getInvolvedTier = (tier) => {
        if (tier === "Freemium") return "Pro";
        if (tier === "Pro") return "Marketing";
        return "Pro";
      };

      const existing = getExistingTier();
      const involved = getInvolvedTier(existing);
      setLoading(true);
      try {
        const response = await _get(
          `/client/pro/request?vFeature=${formatCategoryName(
            props?.cardData?.name
          )}&vExistingTier=${existing}&vInvolvedTier=${involved}`,
        );
        if (response.data.status === "SUCCESS") {
          setSuccessFlag(true);
        }
      } catch (error) {
        showToast(error?.data?.message, "error");
      }
      setLoading(false);
    }
  };
  return (
    <>
      <ContactSalesTeamModal
        show={contactSalesModal}
        cardData={props?.cardData}
        onHide={() => setContactSalesModal(false)}
      />
      <Modal
        {...props}
        size="lg"
        restoreFocus={"true"}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="chamelonTourPopup"
      >
        <Modal.Header className="p-0 m-0 d-none" closeButton />
        <Modal.Body
          style={{ padding: "0px", position: "relative", overflow: "hidden" }}
          className="pt-0 m-0"
          closeButton
        >
          <button
            data-testid="close-upgrade-modal"
            className="position-absolute cursor-pointer border-0 bg-transparent p-0"
            style={{ right: "15px", top: "15px" }}
            onClick={() => props.onHide()}
            aria-label="Close modal"
          >
            <img src={exportimages.FU_cross} alt="Close" />
          </button>
          <div className="d-flex ">
            <div className="w-50">
              <img
                src={
                  successFlag
                    ? exportimages?.contact_sales_team_success_upgrade
                    : exportimages?.[`${props?.cardData?.src}_upgrade`]
                }
                style={{ left: "-0.5%", position: "relative", height: "100%" }}
                // className="p-9"
                alt="Upgrade feature illustration"
              />
            </div>

            <div
              className="d-flex align-items-start flex-column bd-highlight mb-3 p-12 p-xxl-9"
              // style="height: 200px;"
            >
              <div className="mb-auto p-2 bd-highlight">
                <h3
                  className="text-dark fw-bolder lh-lg mb-0"
                  style={{ fontSize: "1.5rem" }}
                >
                  {getTitleText()}
                </h3>
                <div
                  className="text-muted fs-5 fs-3x-6 mt-8"
                  dangerouslySetInnerHTML={{
                    __html: getDescriptionHtml(),
                  }}
                ></div>
              </div>
              <div
                className="p-2 bd-highlight w-100"
                style={{
                  display:
                    userRole === "reseller" || userRole === "bond-admin"
                      ? "none"
                      : "block",
                }}
              >
                {!successFlag && (
                  <button
                    type="button"
                    id="kt_login_password_reset_form_cancel_button "
                    // onClick={() => props.onHide()}
                    className="btn btn-other btn-bond px-8 py-3"
                    data-toggle="collapse"
                    href="#collapseTransactionBlock"
                    // role="button"
                    aria-expanded="false"
                    // disabled={loading}
                    aria-controls="collapseTransactionBlock"
                    onClick={() => {
                      if (!successFlag) {
                        dispatch(setUserContactedSales(true));
                      }
                      handleClick();
                    }}
                    style={{ pointerEvents: loading ? "none" : "all" }}
                  >
                    <span
                      className="me-1 fs-5 fs-xxl-6"
                      style={{ fontWeight: "normal" }}
                      data-testid="contact-sales-label"
                    >
                      {successFlag ? "Dashboard" : "Contact Sales"}
                    </span>
                    <output
                      className="spinner-grow spinner-grow-sm ms-3"
                      id="btn_spinner"
                      style={{ display: loading ? "inline-flex" : "none" }}
                    />
                  </button>
                )}
                {/* 
                <button
                  type="button"
                  id="take-a-tour"
                  className="btn btn-other-outline border-other btn-bond px-4 py-3 ms-4 w-50"
                  data-toggle="collapse"
                  href="#collapseTransactionBlock"
                  style={{
                    display:
                      props?.cardData?.name === "first_time_logged_in"
                        ? "inline-block"
                        : "none",
                  }}
                  aria-expanded="false"
                  aria-controls="collapseTransactionBlock"
                  onClick={() => props.onHide()}
                >
                  <span
                    className="me-1 fs-5 fs-xxl-6  "
                    style={{ fontWeight: "normal" }}
                  >
                    Take the Executive Tour
                  </span>
                </button> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

UpgradeCardSpecificModal.propTypes = {
  cardData: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    src: PropTypes.string,
    description: PropTypes.string,
  }),
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
};
